import {
	Breadcrumbs,
	Button,
	Panel,
	PanelBody,
	PanelHeader
} from "@itandi/itandi-bb-ui";
import Link from "next/link";
import type { FC } from "react";
import { useState } from "react";
import { VendorSettingLayout } from "~/components/common/layouts/settings/VendorSettingLayout";
import { VendorLayoutV2 } from "~/components/common/layouts/VendorLayoutV2";
import { LineUserAccountList } from "~/components/common/line_user_accounts/LineUserAccountList";
import { LineUserAccountModal } from "~/components/common/line_user_accounts/LineUserAccountModal";
import type { LineUserAccountsResponse } from "~/models/LineUserAccount";
import { PATH } from "~/pages/vendors/settings";
import SettingStyles from "../SettingStyle.module.scss";

type Props = {
	lineUserAccounts: LineUserAccountsResponse;
};

export const Page: FC<Props> = ({ lineUserAccounts }: Props) => {
	const [isModalOpen, setIsModalOpen] = useState(false);

	return (
		<VendorLayoutV2>
			<VendorSettingLayout>
				<div className={SettingStyles.SpBreadcrumbsWrapper}>
					<Breadcrumbs
						items={[
							{ as: Link, href: PATH, label: "設定一覧" },
							{ label: "LINE設定" }
						]}
					/>
				</div>
				<Panel>
					<PanelHeader
						rightArea={
							<Button
								onClick={() => {
									setIsModalOpen(true);
								}}
								variant="primary"
							>
								追加
							</Button>
						}
						title="LINEアカウント設定"
					/>
					<PanelBody>
						<LineUserAccountList
							lineUserAccounts={lineUserAccounts.lineUserAccounts}
						/>
						{isModalOpen ? (
							<LineUserAccountModal
								handleClose={() => {
									setIsModalOpen(false);
								}}
							/>
						) : null}
					</PanelBody>
				</Panel>
			</VendorSettingLayout>
		</VendorLayoutV2>
	);
};
